'use client';

import styles from './blog.module.scss';
import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from 'context';
import { Divider, Empty, Input, Pagination, Spin, message } from 'antd';
import BlogCardComp from './blogCard/blogCard.index';
import { __BlogListPropsType } from './blog.type';
import { RestAPI, nextBrowser } from 'scripts';
import { API, PATH } from 'data';
import { BlogPostType, PaginationType } from 'types';
function BlogComp({
  initialFilter,
  posts,
  pageSize
}: __BlogListPropsType) {
  const lang = useContext(GlobalContext).langText.blog;
  const [blogList, setBlogList] = useState<PaginationType<BlogPostType> | undefined>(posts);
  const [filterValues, setFilterValues] = useState({
    ...initialFilter
  });
  const langText = useContext(GlobalContext).langText;
  const [messageApi, contextHolder] = message.useMessage();
  const ordering = [{
    slug: 'created_at',
    label: lang.ordering.newest
  }, {
    slug: 'most-view',
    label: lang.ordering.mostViews
  }
  // { slug: 'most-comment', label: lang.ordering.mostComments },
  ];
  const sortHandler = (slug: string) => {
    setFilterValues({
      ...filterValues,
      order: slug,
      page: '1'
    });
  };
  const onSearch = (text: string) => {
    setFilterValues({
      ...filterValues,
      search: text,
      page: '1'
    });
  };
  useEffect(() => {
    const params: {
      [key: string]: string | string[];
    } = {};
    if (filterValues.category) params.category = filterValues.category;
    if (filterValues.order) params.order = filterValues.order;
    if (filterValues.search) params.search = filterValues.search;
    if (filterValues.page) params.page = filterValues.page;
    const path = new URL(nextBrowser?.window?.location.origin + PATH(langText.lang).blog.index(params));
    window.history.replaceState(null, '', path);
    if (filterValues.category === initialFilter.category && filterValues.order === initialFilter.order && filterValues.search === initialFilter.search && filterValues.page === initialFilter.page) {
      setBlogList(blogList);
    } else {
      const newParams: {
        [key: string]: string | string[];
      } = {};
      if (params.category) newParams.category_and_descendants = params.category;
      if (params.order) newParams.ordering = params.order;
      if (params.search) newParams.title__icontains = params.search;
      if (params.page) newParams.page = params.page;
      setBlogList(undefined);
      RestAPI.get<PaginationType<BlogPostType>>(API.blog.index, {
        ...newParams,
        lang: langText.lang,
        page_size: pageSize
      }).then(res => setBlogList(res.data)).catch(() => {
        messageApi.open({
          type: 'error',
          content: lang.errorMessage
        });
      });
    }
  }, [filterValues]);
  return <div className={`${styles['blog']} main-content flex-1 flex-column`} data-sentry-component="BlogComp" data-sentry-source-file="blog.index.tsx">
            {contextHolder}
            <h2 className="mb-3">{lang.title}</h2>
            <div className={`gap-16 justify-content-between ${styles['desc']}`}>
                <p className={`${styles['text']} d-pre-md-none`}>{lang.desc}</p>
                <Input.Search placeholder={lang.search} className={styles['search']} onSearch={onSearch} allowClear data-sentry-element="unknown" data-sentry-source-file="blog.index.tsx" />
            </div>
            <Divider className="mb-2" data-sentry-element="Divider" data-sentry-source-file="blog.index.tsx" />
            <div className="justify-content-between mb-2">
                <div className="gap-16 flex-wrap">
                    <p className="p-e-1 t-600">{lang.ordering.index}:</p>
                    {ordering.map(item => <p key={item.slug} onClick={() => sortHandler(item.slug)} className={`pointer ${filterValues.order === item.slug ? 't-primary' : ''}`}>
                            {item.label}
                        </p>)}
                </div>
                <div className="gap-8 align-items-center">
                    <Divider type="vertical" data-sentry-element="Divider" data-sentry-source-file="blog.index.tsx" />
                    <p>
                        {posts.count} {lang.result}
                    </p>
                </div>
            </div>
            {blogList ? blogList?.count ? <>
                        <div className={styles['post-list']}>
                            {blogList.data.map((item, index) => <BlogCardComp item={item} key={index} />)}
                            <div className={styles['space']} />
                            <div className={styles['space']} />
                        </div>
                        {blogList && blogList.num_of_pages > 1 && <div className={`${styles['pagination-layout']} d-flex center-content mt-6 mb-10`}>
                                <div className={`${styles['pagination']} d-flex center-content mt-6`}>
                                    <Pagination size="small" current={filterValues.page ? Number(filterValues.page) : 1} pageSize={pageSize} total={blogList.count} showSizeChanger={false} hideOnSinglePage onChange={e => setFilterValues({
            ...filterValues,
            page: e.toString()
          })} />
                                </div>
                            </div>}
                    </> : <Empty className="pv-6 flex-1 center-content flex-column" description={lang.empty} /> : <div className={`w-100 pv-6 center-content flex-1`}>
                    <Spin />
                </div>}
        </div>;
}
export default BlogComp;